// ═══ 인보이스 OCR 핸들러 — useInvoiceState.js 에서 분리 (Phase 2 시동, 2026-05-08) ═══
// 분석 보고서: docs/analysis/use-invoice-state-split-2026-05-08.md
//
// applyOcrResult / handleScreenshot / handleTextPaste 를 pure util 로 분리.
// React state setter 들은 deps 객체로 주입 — useState 의존성 명시화.
import { API, authFetch } from './api';

// OCR 응답(이미지/텍스트 공통) → 폼 반영 + 차량 매칭 처리
// deps: { setSsLoading, setSsResult, setContainerNo, setSealNo, setEntryPoint, setBkNo,
//         setVesselName, setToPort, setFromPort, setSelBuyer, setConsignee, setCarRows,
//         buyers, mkRow, showToast }
export function applyOcrResult(d, sourceLabel, deps) {
  deps.setSsLoading(false);
  if (!d.success) { deps.showToast('OCR 실패: ' + (d.error || ''), 'err'); return; }
  deps.setSsResult(d);
  var o = d.ocrData || {};
  if (o.containerNo) deps.setContainerNo(o.containerNo);
  if (o.sealNo) deps.setSealNo(o.sealNo);
  if (o.entryPoint) deps.setEntryPoint(o.entryPoint);
  if (o.bkNo) deps.setBkNo(o.bkNo);
  if (o.vesselName) deps.setVesselName(o.vesselName);
  if (o.toPort) deps.setToPort(o.toPort);
  else if (o.destination) deps.setToPort(o.destination);
  if (o.fromPort) deps.setFromPort(o.fromPort);
  var buyerStr = o.consignee || o.buyerName || '';
  var addrStr = o.buyerAddress || '';
  if (buyerStr) {
    var match = deps.buyers.find(function(b){ return b.name && b.name.toLowerCase().indexOf(buyerStr.toLowerCase()) >= 0; });
    if (match) {
      deps.setSelBuyer(match);
      deps.setConsignee(addrStr ? (match.name + '\n' + addrStr) : match.name);
      if (addrStr && !match.addr) {
        authFetch(API + '/buyers/' + match.id, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(Object.assign({}, match, { addr: addrStr }))
        }).catch(function(){});
      }
    } else { deps.setConsignee(addrStr ? (buyerStr + '\n' + addrStr) : buyerStr); }
  }
  if (d.matchedCars && d.matchedCars.length > 0) {
    var newRows = d.matchedCars.map(function(c){ return deps.mkRow(c); });
    deps.setCarRows(function(prev){
      var existing = prev.filter(function(r){ return r.vin; });
      var combined = existing.concat(newRows.filter(function(nr){
        return !existing.find(function(er){ return er.vin === nr.vin; });
      }));
      return combined.length > 0 ? combined : [deps.mkRow(null)];
    });
  }
  var msg = (sourceLabel || '스크린샷') + ' 분석 완료';
  if (d.matchedCars && d.matchedCars.length > 0) msg += ' (차량 ' + d.matchedCars.length + '대 매칭)';
  if (d.unmatchedVins && d.unmatchedVins.length > 0) msg += ' / 미등록 ' + d.unmatchedVins.length + '대';
  deps.showToast(msg);
}

// 스크린샷 OCR — 이미지 file → /invoices/screenshot-ocr (FormData)
// deps: applyOcrResult deps + { setSsImageUrl, ssImageUrl }
export function handleScreenshot(file, deps) {
  if (!file) return;
  deps.setSsLoading(true);
  deps.setSsResult(null);
  try { if (deps.ssImageUrl) URL.revokeObjectURL(deps.ssImageUrl); } catch (e) {}
  deps.setSsImageUrl(URL.createObjectURL(file));
  var fd = new FormData();
  fd.append('image', file);
  authFetch(API + '/invoices/screenshot-ocr', { method: 'POST', body: fd })
    .then(function(r){ return r.json(); })
    .then(function(d){ applyOcrResult(d, '스크린샷', deps); })
    .catch(function(){
      deps.setSsLoading(false);
      deps.showToast('스크린샷 분석 실패', 'err');
    });
}

// 텍스트 붙여넣기 OCR — Clova 생략, 바로 Haiku 구조화
// deps: applyOcrResult deps + { setSsImageUrl, ssImageUrl }
export function handleTextPaste(text, deps) {
  if (!text || !text.trim()) return;
  deps.setSsLoading(true);
  deps.setSsResult(null);
  try { if (deps.ssImageUrl) URL.revokeObjectURL(deps.ssImageUrl); } catch (e) {}
  deps.setSsImageUrl('');
  authFetch(API + '/invoices/screenshot-ocr', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ text: text })
  })
    .then(function(r){ return r.json(); })
    .then(function(d){ applyOcrResult(d, '텍스트', deps); })
    .catch(function(){
      deps.setSsLoading(false);
      deps.showToast('텍스트 분석 실패', 'err');
    });
}
